import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { UserDivisions } from '@app/@core/constants/user-credentials.constants';
import { MonthlyResult, MonthlyStatusAuto, MonthlyStatusConsumption } from '@app/activity/model/activity-model';

const COLUMN_CONSUMPTION = ['status', 'cic', 'tjt', 'total', 'finance', 'prot'];
const COLUMN_AUTOS = [
  'status',
  'cia',
  'cip',
  'cic',
  'co',
  'lc',
  'total',
  'finance',
  'incTotal',
  'incVendor',
  'ppp',
  'ppb',
  'ppt',
  'protection',
];

@Component({
  selector: 'scf-current-month-table',
  templateUrl: './current-month-table.component.html',
  styleUrls: ['./current-month-table.component.scss'],
})
export class CurrentMonthTableComponent implements OnInit, OnChanges {
  @Input('title') title: string = '';
  @Input('data') data: MonthlyResult;
  @Input('division') division: number;

  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource<MonthlyStatusAuto | MonthlyStatusConsumption>();

  isOpened: boolean = false;

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    console.log('changes', changes);
    if (changes?.data) {
      if (this.division === UserDivisions.AUTOS) {
        this.dataSource.data = this.data?.statusAuto;
        console.log('dataSource', this.dataSource.data);
      } else if (this.division === UserDivisions.CONSUMPTION) {
        this.dataSource.data = this.data?.statusConsumption;
      } else {
        console.error('Division NOT FOUND: ', this.division);
      }
    }
  }

  ngOnInit(): void {
    this.displayedColumns =
      this.division === UserDivisions.CONSUMPTION
        ? COLUMN_CONSUMPTION
        : this.division === UserDivisions.AUTOS
        ? COLUMN_AUTOS
        : [];
  }

  onClickExpandButton = () => {
    this.isOpened = !this.isOpened;
  };
}
